import { Phone, Truck, MapPin, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmergencyBar({ company, roadside }) {
  const phone = company.phone_emergency || company.phone;
  if (!roadside?.enabled) return null;
  return (
    <section id="asistenta" className="relative -mt-8 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          data-testid="roadside-emergency-banner"
          className="grain-overlay flex flex-col md:flex-row items-center justify-between gap-6 p-6 sm:p-8 rounded-2xl bg-[#12151A] text-white shadow-2xl border border-white/5"
        >
          <div className="flex items-center gap-4">
            <span className="shrink-0 w-14 h-14 rounded-xl bg-[#FF5A1F] flex items-center justify-center">
              <Truck className="w-7 h-7 text-white" />
            </span>
            <div>
              <h3 className="font-display text-xl sm:text-2xl font-bold">
                {roadside.title}
              </h3>
              <p className="text-sm text-white/60 mt-1">
                {roadside.subtitle}
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
            <div className="hidden lg:flex items-center gap-2 text-white/50 text-sm font-mono">
              <Clock className="w-4 h-4 text-[#FF5A1F]" />
              Răspuns rapid
            </div>
            <a
              href={`tel:${phone?.replace(/\s/g, "")}`}
              data-testid="roadside-call-now-button"
              className="w-full sm:w-auto"
            >
              <Button className="w-full bg-[#FF5A1F] hover:bg-[#E04B14] text-white font-bold text-base px-8 py-6">
                <Phone className="w-5 h-5 mr-2" />
                {phone}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
